/* global seatKillsCategoriesDeleteUrl seatKillsCategoriesUpsertUrl seatKillsCategoriesUrl seatKillsIndexUrl seatKillsSaveUrl */

import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import { SeatKillsCategories } from './SeatKillsCategories';
import { SeatKillsTable } from './SeatKillsTable';

import { useToast } from 'Hooks/useToast';

export default function SeatKillsIndex(props) {
    const [categories, setCategories] = useState([]);
    const [events, setEvents] = useState([]);
    const [categoriesByGroup, setCategoriesByGroup] = useState({ kills: [], holds: [] });
    const [sportVenues, setSportVenues] = useState([]);
    const [fetchingSeatKills, setFetchingSeatKills] = useState(false);
    const [fetchedEvents, setFetchedEvents] = useState(false);

    const toast = useToast();

    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchSeatKills = () => {
        setFetchingSeatKills(true);

        axios
            .get(props.indexUrl)
            .then((res) => {
                const { data, sport_venues } = res.data;
                setCategoriesByGroup(res.data.categories);
                setEvents(data);
                setSportVenues(sport_venues);
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                setFetchingSeatKills(false);
            });
    };

    const saveSeatKills = (data, callback = null) => {
        return axios
            .post(props.saveUrl, data)
            .then((res) => {
                fetchSeatKills();
                toast.success(res.data.message);
                if (callback) {
                    callback();
                }
            })
            .catch((err) => {
                const message = err.response?.data?.message || err.response?.data?.error || $t('Something went wrong while saving seat kills');
                toast.error(message);
                console.log(err);
            });
    };

    const fetchCategories = () => {
        axios
            .get(props.fetchUrl)
            .then(({ data }) => {
                setCategories(data);
                fetchSeatKills();
                setFetchedEvents(true);
            })
            .catch((error) => {
                toast.error(error.data?.message || $t('Something went wrong!'));
                console.log(error);
            });
    };

    return (
        <div>
            <SeatKillsCategories categories={categories} fetchCategories={fetchCategories} upsertUrl={props.upsertUrl} deleteUrl={props.deleteUrl} />
            {fetchedEvents && (
                <SeatKillsTable
                    categories={categoriesByGroup}
                    events={events}
                    sportVenues={sportVenues}
                    loading={fetchingSeatKills}
                    saveSeatKills={saveSeatKills}
                />
            )}
        </div>
    );
}

if (document.getElementById('seatKillsAndHolds')) {
    var rootEl = document.getElementById('seatKillsAndHolds');
    ReactDOM.render(
        <App>
            <SeatKillsIndex
                fetchUrl={seatKillsCategoriesUrl}
                upsertUrl={seatKillsCategoriesUpsertUrl}
                deleteUrl={seatKillsCategoriesDeleteUrl}
                indexUrl={seatKillsIndexUrl}
                saveUrl={seatKillsSaveUrl}
            />
        </App>,
        rootEl,
    );
}
